var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('app-dropdown-menu',{attrs:{"title":"Action","list":_vm.menuList},on:{"action":_vm.triggerAction}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }